
import Container from '@mui/material/Container';
import CustomContainer from '../components/CustomContainer';
import Typography from '@mui/material/Typography';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import {  useState  } from "react";
import {useNavigate} from 'react-router-dom'
import DashboardContext from '../context/DashboardContext';
import { useEffect , useContext } from 'react';
import { MovementBox} from '../components/MovementBox'
import CustomButton from "../components/CustomButton"
import { getMovement } from '../services';
import { CircularProgress } from "@mui/material";
import {Box} from "@mui/material";

export function Movimentos(){
    const [movements , setMovements] = useState([]);
    const [isLoading , setIsLoading] = useState(false);
    
    const navigation = useNavigate();

    async function getMoviments(){
      setIsLoading(true)
      const newMovements = await getMovement();
      setMovements(newMovements);
      setIsLoading(false)
    }
    const {setMovementUrl , panelTitle} = useContext(DashboardContext);

    useEffect(()=>{
      getMoviments()
    },[])
    return(
      <Container>
        <CustomContainer
          style={{ padding: "32px 48px" }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minWidth: 1100,
          }}
        >

          { /* TÍTULO DA PÁGINA */}
           <Typography
            color="primary"
            component="h2"
            mb={4}
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
            variant="h4"
          >
            <CameraEnhanceIcon fontSize="md" sx={{ mr: 1 }} />
            Movimentos
          </Typography>

          { !isLoading ? movements.map((movement)=>(
            <MovementBox >
            <img  alt={movement.imagem} width='200px' src={`https://clubecerto.com.br/gema/movimento/images/${movement.imagem}`}/>

            <p dangerouslySetInnerHTML={{__html: movement.descricao}}></p>

            <div style={{display:"flex" , flexDirection:"column" , alignItems:'center' , justifyContent:'center'}}>
            
            <CustomButton sx={{ fontSize:17 , fontWeight:800 , marginBottom:"10px" , opacity:0.9, "&:hover":{
              opacity:1
            } }} onClick={()=>{
                  sessionStorage.setItem("movementUrl" ,
                  `https://clubecerto.com.br/gema/movimento/images/${movement.imagem}`);

                  setMovementUrl(`https://clubecerto.com.br/gema/movimento/images/${movement.imagem}`);
                  navigation('/imagem-movimento');
            }}>
              Baixar Post
            </CustomButton>

            <a download={panelTitle + "_" + movement.psd} 
            href={`https://clubecerto.com.br/gema/movimento/images/${movement.psd}`} 
            style={{textDecoration:'none'}} >

            <CustomButton sx={{ fontSize:17 , fontWeight:800 ,opacity:0.9, "&:hover":{
              opacity:1
            }}}>
              Baixar Kit
            </CustomButton>

            </a>

            </div>
            
          </MovementBox>
          )) : <Box sx={{ display: "flex", justifyContent: "center", py: 2, width: "100%" }}>
          <CircularProgress />
        </Box>}
          
        </CustomContainer>
        </Container>
    )
}